import React, { useState } from 'react';

// 더미 데이터
const dummySubscribers = [
  {
    id: 1,
    name: '김지원',
    profileImage: 'https://via.placeholder.com/40',
    subscriptionDate: '2024-03-01',
    lastActive: '2024-03-15',
    status: 'active',
    level: '초급',
  },
  {
    id: 2,
    name: '이수진',
    profileImage: 'https://via.placeholder.com/40',
    subscriptionDate: '2024-02-15',
    lastActive: '2024-03-14',
    status: 'active',
    level: '중급',
  },
  {
    id: 3,
    name: '박민준',
    profileImage: 'https://via.placeholder.com/40',
    subscriptionDate: '2024-01-20',
    lastActive: '2024-03-10',
    status: 'inactive',
    level: '고급',
  },
];

const KoachContentsSubscriber = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <main className="bg-gray-50 min-h-screen !pt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* 헤더 영역 */}
        <div className="fixed top-0 left-0 right-0 bg-gray-50 z-10 border-b border-gray-200">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex items-center gap-4 mb-4">
              <h1 className="text-lg font-bold text-gray-900">
                구독자 관리
              </h1>
            </div>
            <div className="flex items-center justify-between">
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
                <div className="flex space-x-4">
                  <button
                    onClick={() => setSelectedTab(0)}
                    className={selectedTab === 0 ? `text-[#CF3688]` : `text-gray-400`}>
                    전체 구독자
                  </button>
                  <button
                    onClick={() => setSelectedTab(1)}
                    className={selectedTab === 1 ? `text-[#CF3688]` : `text-gray-400`}>
                    활성 구독자
                  </button>
                  <button
                    onClick={() => setSelectedTab(2)}
                    className={selectedTab === 2 ? `text-[#CF3688]` : `text-gray-400`}>
                    비활성 구독자
                  </button>
                </div>
              </h2>
            </div>
          </div>
        </div>

        {/* 구독자 목록 영역 */}
        <div className="pt-32">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        구독자
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        구독일
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        최근 활동
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        레벨
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        상태
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {dummySubscribers.map((subscriber) => (
                      <tr key={subscriber.id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <div className="flex-shrink-0 h-10 w-10">
                              <img
                                className="h-10 w-10 rounded-full"
                                src={subscriber.profileImage}
                                alt={subscriber.name}
                              />
                            </div>
                            <div className="ml-4">
                              <div className="text-sm font-medium text-gray-900">
                                {subscriber.name}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">{subscriber.subscriptionDate}</div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">{subscriber.lastActive}</div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800">
                            {subscriber.level}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            subscriber.status === 'active' 
                              ? 'bg-green-100 text-green-800' 
                              : 'bg-red-100 text-red-800'
                          }`}>
                            {subscriber.status === 'active' ? '활성' : '비활성'}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default KoachContentsSubscriber;